import Component from '@glimmer/component';
import { guidFor } from '@ember/object/internals';
import { htmlSafe } from '@ember/template';
import { link } from 'reactiveweb/link';
import { HostMessaging } from './frame-messaging.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';
import { g, i } from 'decorator-transforms/runtime';

const DEFAULT_NUMBER_OF_LINES = 7;
// TODO: allow import.meta.env to override this
let HOST = 'https://limber.glimdown.com/edit';
const initialQPs = new URLSearchParams(window.location.search);
if (initialQPs.get('local')) {
  HOST = `http://localhost:${initialQPs.get('local')}`;
}
const INITIAL_URL = force => `${HOST}?format=gjs&t=<template></template>` + (force ? `&forceEditor=${force}` : '');
function defaultStyle(lines) {
  return `height: calc(1.5rem * ${lines});`;
}
class Code extends Component {
  static {
    g(this.prototype, "messaging", [link(HostMessaging)]);
  }
  #messaging = (i(this, "messaging"), void 0);
  get code() {
    if ('code' in this.args) {
      return this.args.code;
    }
    return '';
  }
  get lines() {
    return this.code?.split('\n')?.length ?? DEFAULT_NUMBER_OF_LINES;
  }
  get title() {
    return this.args.title ?? guidFor(this.code);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <iframe {{this.messaging.postMessage this.code}} {{this.messaging.onMessage}} title={{this.title}} src={{htmlSafe (INITIAL_URL @editor)}} style={{htmlSafe (defaultStyle this.lines)}} ...attributes>\n    </iframe>\n  ", {
      strictMode: true,
      scope: () => ({
        htmlSafe,
        INITIAL_URL,
        defaultStyle
      })
    }), this);
  }
}

export { Code as default };
//# sourceMappingURL=code.js.map
